import { bluePalette, goodPalette, extendedGoodPalette, badPalette, reversedGoodPalette, reversedBadPalette, strongSupport, weakSupport, weakOppose, strongOppose, neutral } from "../../../../src/utils/pulsePalette.js";
import direction from "../../../../src/images/icons/direction.svg";
import mayor from "../../../../src/images/icons/mayor.svg";
import updown from "../../../../src/images/icons/updown.svg";
import smallBiz from "../../../../src/images/icons/small-business.svg";
import homeless from "../../../../src/images/icons/homeless.svg";
import wfh from "../../../../src/images/icons/work-from-home.svg";
import downtown from "../../../../src/images/icons/downtown.svg";
import { H1, H3 } from "../../../../src/components/layout/headings";
import { SupportOpposeLineChart, LurieFavorability, BOSFavorability } from "../../../../src/components/pulse/lineChart.js";
import { TopBottomIssuesBump } from "../../../../src/components/pulse/RankedIssuesLineChart.js";
import CrossTabChart from "../../../../src/components/pulse/CrossTabChart";
import { Collapsible } from "../../../../src/components/layout/collapsible";
import { IssuesDumbbellChart } from "../../../../src/components/pulse/IssuesDumbbellChart";
import * as React from 'react';
export default {
  bluePalette,
  goodPalette,
  extendedGoodPalette,
  badPalette,
  reversedGoodPalette,
  reversedBadPalette,
  strongSupport,
  weakSupport,
  weakOppose,
  strongOppose,
  neutral,
  direction,
  mayor,
  updown,
  smallBiz,
  homeless,
  wfh,
  downtown,
  H1,
  H3,
  SupportOpposeLineChart,
  LurieFavorability,
  BOSFavorability,
  TopBottomIssuesBump,
  CrossTabChart,
  Collapsible,
  IssuesDumbbellChart,
  React
};